const skills = [
  {
    title: "Expertise",
    technologies: ["Docker Networking", "DevOps", "CI/CD", "Virtualization", "DNS", "DHCP", "TCP/IP", "Commissioning"]
  },
  {
    title: "Software",
    technologies: ["SolidWorks", "CATIA", "Maple", "AutoCAD", "Mathematica", "GNU Octave", "ANSYS-Fluent"]
  },
  {
    title: "Robotics",
    technologies: ["CoppeliaSim", "Gazebo", "Simulink", "Kawasaki CS", "Keyence GC", "PLC Programming"]
  },
  {
    title: "Project Management",
    technologies: ["Jira", "SmartSheet", "Monday", "Agile", "Scrum", "Kanban"]
  }
];

export default skills;
